import parse from 'html-react-parser';

//components
import { PillLink } from '@/containers-ai/Buttons';
import { Grad } from '@/containers-ai/SectionHeading';

//containers
import { HeroVisual } from './HeroVisual';

//styles
import {
  HeroSection,
  HeroInner,
  HeroTop,
  HeroCopy,
  Eyebrow,
  HeroTitle,
  HeroSub,
  CtaRow,
  HeroImageWrap,
} from './Hero.styles';

export function Hero({ content }) {
  return (
    <HeroSection id="top">
      <HeroInner>
        <HeroTop>
          <HeroCopy>
            <Eyebrow>{content.eyebrow}</Eyebrow>
            <HeroTitle>
              {content.title}
              <br />
              <Grad>{content.titleHighlight}</Grad>
            </HeroTitle>
            <HeroSub>{content.copy1}</HeroSub>
            <HeroSub>{parse(content.copy2)}</HeroSub>
            <CtaRow>
              <PillLink
                className="qlf-btn-7"
                href={content.ctaHref ?? '/contact/#contact-form'}
              >
                {content.ctaLabel}
              </PillLink>
            </CtaRow>
          </HeroCopy>

          <HeroImageWrap>
            <HeroVisual content={content.visual} />
          </HeroImageWrap>
        </HeroTop>
      </HeroInner>
    </HeroSection>
  );
}
